"use strict";
exports.__esModule = true;
//# sourceMappingURL=investors-tabs-slice.js.map